
import { useParams } from 'react-router-dom';
import { ClienteFormState } from '../../../context/cliente/ClienteFormState';
import { Form } from './formclienteForgotPassword';

export const ClienteForgotPasswordPage = () => {
    return (
    <ClienteFormState>
        <br />
        <Form title="Recuperar contraseña" />
    </ClienteFormState>
  );
};
